import * as types from './types'

export const mutations = {
    [types.SET_WORK_PROCESSES](state, { workProcesses, totalPages }) {
        state.workProcesses = workProcesses
        state.totalPages = totalPages
    },
    [types.SET_WORK_PROCESSES_AVAILABLE](state, payload) {
        state.workProcessesAvailable = payload.workProcessesAvailable;
        state.totalPagesAvailable = payload.totalPagesAvailable;
    },
    [types.ADD_WORK_PROCESS](state, workProcess) {
        state.workProcesses.unshift(workProcess)
    },
    [types.UPDATE_WORK_PROCESS](state, updatedWorkProcess) {
        const index = state.workProcesses.findIndex(wp => wp.id === updatedWorkProcess.id)
        if (index !== -1) {
            state.workProcesses.splice(index, 1, updatedWorkProcess)
        }
    },
    [types.DELETE_WORK_PROCESS](state, id) {
        state.workProcesses = state.workProcesses.filter(wp => wp.id !== id)
        delete state.tasks[id]
    },
    [types.SET_TASKS](state, { workProcessId, tasks }) {
        state.tasks = {
            ...state.tasks,
            [workProcessId]: tasks
        }
    },[types.UPDATE_TASK](state, { workProcessId, tasks }) {
        state.tasks = {
            ...state.tasks,
            [workProcessId]: tasks
        }
    },
    [types.SET_LOADING](state, loading) {
        state.loading = loading
    },
    [types.SET_ERROR](state, error) {
        state.error = error
    },
    [types.SET_VEHICLE_MODELS](state, vehicleModels) {
        state.vehicleModels = vehicleModels
    },
    [types.SET_ITEM_DETAILS](state, { itemId, value }) {
        const itemIndex = state.workProcesses.findIndex(wp => wp.id === itemId);
        if (itemIndex !== -1) {
            state.workProcesses = [
                ...state.workProcesses.slice(0, itemIndex),
                {
                    ...state.workProcesses[itemIndex],
                    _showDetails: value
                },
                ...state.workProcesses.slice(itemIndex + 1)
            ];
        }
    },

    [types.SET_ITEM_LOADING](state, { itemId, value }) {
        const itemIndex = state.workProcesses.findIndex(wp => wp.id === itemId);
        if (itemIndex !== -1) {
            state.workProcesses = [
                ...state.workProcesses.slice(0, itemIndex),
                {
                    ...state.workProcesses[itemIndex],
                    _loadingTasks: value
                },
                ...state.workProcesses.slice(itemIndex + 1)
            ];
        }
    },

    [types.SET_ITEM_TASKS](state, { itemId, tasks }) {
        const itemIndex = state.workProcesses.findIndex(wp => wp.id === itemId);
        if (itemIndex !== -1) {
            state.workProcesses = [
                ...state.workProcesses.slice(0, itemIndex),
                {
                    ...state.workProcesses[itemIndex],
                    tasks
                },
                ...state.workProcesses.slice(itemIndex + 1)
            ];
        }
    },

    [types.SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    }
}
